export const CATALOGUE_FILTERS_KEY = 'catalogue-filters';
export const CATALOGUE_FILTERS_INTERACTED_KEY = 'catalogue-filters-interacted';
export const CONTENT_VIEW_PREFERENCE_KEY = 'content-view-preference';
export const CSV_UPLOAD_ERRORS_KEY = 'csvUploadErrors';
export const PENDING_LOGIN_EVENT_KEY = 'pendingLoginEvent';
